import ikdReducer from "./reducers"

export default ikdReducer